/* ══════════════════════════════════════════════════════════
   JCG Royale Wedding — Product configurator
   Handles option selection, variant matching, custom size
   measurement reveal, gallery thumbs, and async add-to-cart.
══════════════════════════════════════════════════════════ */
(function() {
  var sections = document.querySelectorAll('[data-jrw-section]');
  if (!sections.length) return;

  sections.forEach(function(sectionEl) {
    var sectionId = sectionEl.getAttribute('data-jrw-section');

    /* ── Variant data ─────────────────── */
    var variantScript = sectionEl.querySelector('[data-jrw-variants]');
    if (!variantScript) return;
    var variants;
    try {
      variants = JSON.parse(variantScript.textContent);
    } catch (err) {
      console.error('[jrw] variant parse error', err);
      return;
    }

    var form = sectionEl.querySelector('[data-jrw-form]');
    var variantInput = sectionEl.querySelector('#jrwVariantId-' + sectionId);
    var priceEl = sectionEl.querySelector('#jrwPrice-' + sectionId);
    var measurePanel = sectionEl.querySelector('#jrwMeasure-' + sectionId);
    var submitBtn = sectionEl.querySelector('[data-jrw-submit]');
    var submitText = sectionEl.querySelector('[data-jrw-submit-text]');
    var colorLabel = sectionEl.querySelector('[data-jrw-color-label]');

    /* ── Color value → array of media indices (for jumping gallery on swatch click) ── */
    var colorMedia = {};
    var colorMediaScript = sectionEl.querySelector('[data-jrw-color-media]');
    if (colorMediaScript) {
      try { colorMedia = JSON.parse(colorMediaScript.textContent); } catch (e) {}
    }
    // Normalize keys to lowercase for case-insensitive lookup
    var colorMediaLC = {};
    Object.keys(colorMedia).forEach(function(k) {
      colorMediaLC[k.toLowerCase()] = colorMedia[k];
    });

    /* Placeholder — will be replaced by the carousel block below if a gallery exists. */
    var goToSlide = function() {};

    function jumpToColorMedia(colorValue) {
      if (!colorValue) return;
      var list = colorMediaLC[String(colorValue).toLowerCase()];
      if (list && list.length > 0) {
        goToSlide(list[0]);
      }
    }

    /* ── Selected options state ───────── */
    var selected = {};
    // Non-dropdown pickers (swatches, fallback chips). Size is its own jcd dropdown.
    var pickers = sectionEl.querySelectorAll('.jrw-swatch, .jrw-chip');
    pickers.forEach(function(btn) {
      if (btn.classList.contains('is-selected')) {
        selected[btn.dataset.jrwOptionName] = btn.dataset.jrwOptionValue;
      }
    });

    function optionNames() {
      // Return the product option names in order (one per .jrw-option group)
      var opts = sectionEl.querySelectorAll('.jrw-option');
      var names = [];
      opts.forEach(function(opt) {
        var firstBtn = opt.querySelector('.jrw-swatch, .jrw-chip, [data-jrw-option-value]');
        if (firstBtn) names.push(firstBtn.dataset.jrwOptionName);
      });
      return names;
    }

    function findVariant() {
      var names = optionNames();
      var values = names.map(function(n) { return selected[n]; });
      return variants.find(function(v) {
        return names.every(function(n, i) {
          return v['option' + (i + 1)] === values[i];
        });
      });
    }

    function formatMoney(cents) {
      // Use Shopify's formatMoney if available, fallback to USD
      if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
        return window.theme.Currency.formatMoney(cents);
      }
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }

    /* Recompute which size values are available for the currently-selected color
       and reflect that in the jcd dropdown. Sizes without any matching variant
       (or whose only variants are sold out) are marked unavailable. */
    function updateSizeAvailability() {
      var names = optionNames();
      var sizeName = null;
      var sizeIdx = -1;
      for (var i = 0; i < names.length; i++) {
        if (names[i].toLowerCase().indexOf('size') !== -1) {
          sizeName = names[i];
          sizeIdx = i;
          break;
        }
      }
      if (sizeIdx === -1) return;

      sectionEl.querySelectorAll('[data-jrw-jcd] [data-jrw-option-value]').forEach(function(opt) {
        if (opt.dataset.jrwOptionName !== sizeName) return;
        var sizeValue = opt.dataset.jrwOptionValue;
        // "Custom" is a made-to-order size — always available regardless of variants.
        if (String(sizeValue).toLowerCase() === 'custom') {
          opt.classList.remove('is-unavailable', 'is-soldout');
          opt.removeAttribute('aria-disabled');
          return;
        }
        // Find any variant matching the currently-selected non-size options + this size.
        var matching = variants.filter(function(v) {
          if (v['option' + (sizeIdx + 1)] !== sizeValue) return false;
          for (var j = 0; j < names.length; j++) {
            if (j === sizeIdx) continue;
            if (selected[names[j]] && v['option' + (j + 1)] !== selected[names[j]]) return false;
          }
          return true;
        });
        var hasAny = matching.length > 0;
        var anyAvailable = matching.some(function(v) { return v.available; });
        opt.classList.toggle('is-unavailable', !hasAny);
        opt.classList.toggle('is-soldout', hasAny && !anyAvailable);
        if (!hasAny || !anyAvailable) {
          opt.setAttribute('aria-disabled', 'true');
        } else {
          opt.removeAttribute('aria-disabled');
        }
      });
    }

    function updateVariant() {
      updateSizeAvailability();

      var variant = findVariant();
      if (!variant) {
        variantInput.value = '';
        if (submitBtn) {
          submitBtn.disabled = true;
          if (submitText) {
            /* Decide WHY the variant is missing — partial selection (user
               hasn't picked color or size yet) or genuine combo unavailable.
               Walks the option names in order and picks the first one with
               no value, then renders "Select <option name>". This way the
               button is informative instead of generically "Unavailable",
               and the disabled state matches the partial-selection state. */
            var names = optionNames();
            var missing = null;
            for (var i = 0; i < names.length; i++) {
              if (!selected[names[i]]) { missing = names[i]; break; }
            }
            submitText.textContent = missing
              ? 'Select ' + missing.toLowerCase()
              : 'Unavailable';
          }
        }
        // Still update color label + measurement panel reveal for partial selections
        syncAncillary();
        return;
      }
      variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        if (submitText) {
          submitText.textContent = variant.available
            ? (submitBtn.dataset.defaultText || submitBtn.getAttribute('data-default-text') || submitText.textContent)
            : 'Sold out';
        }
      }
      syncAncillary();
    }

    function syncAncillary() {
      // Update color label display
      if (colorLabel) {
        var colorValue = selected['Color'] || selected['Colour'] || selected['color'] || selected['colour'];
        if (colorValue) colorLabel.textContent = '— ' + colorValue;
      }

      // Reveal measurement panel when size = Custom
      var sizeValue = selected['Size'] || selected['size'];
      var isCustom = sizeValue && String(sizeValue).toLowerCase() === 'custom';

      if (measurePanel) {
        if (isCustom) {
          measurePanel.hidden = false;
        } else {
          measurePanel.hidden = true;
          // Clear measurement inputs when switching away from custom
          measurePanel.querySelectorAll('[data-jrw-measure]').forEach(function(input) {
            input.value = '';
          });
        }
      }
    }

    /* Capture initial submit text so we can restore it */
    if (submitBtn && submitText) {
      submitBtn.setAttribute('data-default-text', submitText.textContent);
    }

    /* ── Picker click handlers (swatches, chips) ──────────── */
    pickers.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var optName = btn.dataset.jrwOptionName;
        var optValue = btn.dataset.jrwOptionValue;
        selected[optName] = optValue;
        var parent = btn.closest('.jrw-option');
        if (parent) {
          parent.querySelectorAll('.jrw-swatch, .jrw-chip').forEach(function(c) {
            c.classList.remove('is-selected');
          });
        }
        btn.classList.add('is-selected');
        // If this is a color swatch, jump the gallery to the matching media
        if (btn.classList.contains('jrw-swatch')) {
          jumpToColorMedia(optValue);
        }
        updateVariant();
      });
    });

    /* ── Size dropdown (jcd pattern) ──────────── */
    var jcdWraps = sectionEl.querySelectorAll('[data-jrw-jcd]');
    jcdWraps.forEach(function(wrap) {
      var trigger = wrap.querySelector('[data-jrw-jcd-trigger]');
      var list = wrap.querySelector('[data-jrw-jcd-options]');
      var textEl = trigger && trigger.querySelector('.jcd-trigger__text');
      if (!trigger || !list || !textEl) return;

      function closeList() {
        list.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
      function openList() {
        list.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }

      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        if (list.classList.contains('is-open')) {
          closeList();
        } else {
          openList();
        }
      });

      list.querySelectorAll('[data-jrw-option-value]').forEach(function(opt) {
        opt.addEventListener('click', function() {
          if (opt.getAttribute('aria-disabled') === 'true') return;
          var optName = opt.dataset.jrwOptionName;
          var optValue = opt.dataset.jrwOptionValue;
          selected[optName] = optValue;

          list.querySelectorAll('.jcd-option').forEach(function(o) {
            o.classList.remove('is-selected');
            o.setAttribute('aria-selected', 'false');
          });
          opt.classList.add('is-selected');
          opt.setAttribute('aria-selected', 'true');

          textEl.textContent = optValue;
          textEl.removeAttribute('data-placeholder');
          closeList();
          updateVariant();
        });
      });

      document.addEventListener('click', function(e) {
        if (!wrap.contains(e.target)) closeList();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeList();
      });
    });

    /* ── Gallery: single-pane carousel + click-to-zoom ─── */
    var carousel = sectionEl.querySelector('[data-jrw-carousel]');
    if (carousel) {
      var track = carousel.querySelector('[data-jrw-track]');
      var slides = carousel.querySelectorAll('.jrw-gallery__slide');
      var prevBtn = carousel.querySelector('[data-jrw-prev]');
      var nextBtn = carousel.querySelector('[data-jrw-next]');
      var thumbs = sectionEl.querySelectorAll('[data-jrw-thumb]');
      var total = slides.length;
      var index = 0;

      if (total <= 1) {
        carousel.classList.add('is-single');
      }

      /* Single-pane layout everywhere: each slide is 100% wide, so one step of
         the index translates the track by 100%. */
      function maxIndex() {
        return Math.max(0, total - 1);
      }
      function updateCarousel() {
        if (index > maxIndex()) index = maxIndex();
        if (track) track.style.transform = 'translateX(-' + (100 * index) + '%)';
        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= maxIndex();
        thumbs.forEach(function(t, i) {
          t.classList.toggle('is-active', i === index);
        });
      }

      /* Exposed jump-to function — used by variant change to swap images on color pick. */
      goToSlide = function(i) {
        if (typeof i !== 'number' || isNaN(i)) return;
        index = Math.max(0, Math.min(i, maxIndex()));
        updateCarousel();
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          index = Math.max(0, index - 1);
          updateCarousel();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          index = Math.min(maxIndex(), index + 1);
          updateCarousel();
        });
      }
      thumbs.forEach(function(thumb, i) {
        thumb.addEventListener('click', function() {
          index = Math.min(i, maxIndex());
          updateCarousel();
        });
      });

      window.addEventListener('resize', updateCarousel);

      /* Click-to-zoom: injects a magnifier toggle at the bottom-right of each
         slide. Click the toggle (or anywhere on the image) to enter zoom;
         cursor pans the zoomed image; click again (or press Escape) to exit. */
      var ZOOM_ICON_IN = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';
      var ZOOM_ICON_OUT = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';

      /* Detect true hover capability. On touch devices the browser synthesizes
         a mouseleave immediately after the tap-click, which was exiting the
         zoom as soon as it entered. We only bind the hover handlers when the
         device actually supports hover; touch devices use touchmove to pan
         and a second tap to exit. */
      var hasHover = window.matchMedia('(hover: hover)').matches;

      sectionEl.querySelectorAll('[data-jrw-zoom]').forEach(function(zoom) {
        var img = zoom.querySelector('img');
        if (!img) return;

        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'jrw-zoom-toggle';
        toggle.setAttribute('aria-label', 'Zoom image');
        toggle.setAttribute('aria-pressed', 'false');
        toggle.innerHTML = ZOOM_ICON_IN;
        zoom.appendChild(toggle);

        /* Load the high-res image on first zoom. Until then the gallery uses
           the ~1200-1800w version the browser picked via srcset, which isn't
           enough pixels for a 2.2× transform scale. Swap src to the 3000w
           variant on demand, then keep it cached for subsequent zooms. */
        var highResLoaded = false;
        function loadHighRes() {
          if (highResLoaded) return;
          var src = img.getAttribute('data-zoom-src');
          if (!src) return;
          highResLoaded = true;
          var preload = new Image();
          preload.onload = function() {
            img.src = src;
            // Drop srcset so the browser can't re-pick a lower variant on resize.
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
          };
          preload.src = src;
        }

        function setOrigin(clientX, clientY) {
          var rect = zoom.getBoundingClientRect();
          var x = ((clientX - rect.left) / rect.width) * 100;
          var y = ((clientY - rect.top) / rect.height) * 100;
          x = Math.max(0, Math.min(100, x));
          y = Math.max(0, Math.min(100, y));
          img.style.transformOrigin = x + '% ' + y + '%';
        }

        function setZoomed(on) {
          if (on) loadHighRes();
          zoom.classList.toggle('is-zooming', on);
          toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
          toggle.innerHTML = on ? ZOOM_ICON_OUT : ZOOM_ICON_IN;
          if (!on) img.style.transformOrigin = 'center center';
        }

        zoom.addEventListener('click', function(e) {
          // Ignore clicks on carousel nav (they sit above)
          if (e.target.closest('.jrw-gallery__nav')) return;
          var entering = !zoom.classList.contains('is-zooming');
          if (entering && e.clientX != null) setOrigin(e.clientX, e.clientY);
          setZoomed(entering);
        });

        if (hasHover) {
          zoom.addEventListener('mousemove', function(e) {
            if (!zoom.classList.contains('is-zooming')) return;
            setOrigin(e.clientX, e.clientY);
          });

          zoom.addEventListener('mouseleave', function() {
            // Exit zoom when the cursor leaves the image
            if (zoom.classList.contains('is-zooming')) setZoomed(false);
          });
        } else {
          // Touch devices: drag your finger across the image to pan while zoomed.
          zoom.addEventListener('touchmove', function(e) {
            if (!zoom.classList.contains('is-zooming')) return;
            if (!e.touches || !e.touches.length) return;
            e.preventDefault(); // stop the page from scrolling during the pan
            var t = e.touches[0];
            setOrigin(t.clientX, t.clientY);
          }, { passive: false });
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape') return;
        sectionEl.querySelectorAll('[data-jrw-zoom].is-zooming').forEach(function(zoom) {
          zoom.classList.remove('is-zooming');
          var img = zoom.querySelector('img');
          if (img) img.style.transformOrigin = 'center center';
          var toggle = zoom.querySelector('.jrw-zoom-toggle');
          if (toggle) {
            toggle.setAttribute('aria-pressed', 'false');
            toggle.innerHTML = ZOOM_ICON_IN;
          }
        });
      });

      updateCarousel();
    }

    /* ── Form submit (async via Impulse AjaxProduct → opens cart drawer) ── */
    if (form) {
      // Pre-handler in capture phase so it runs before Impulse's submit listener.
      // Blocks submission if no variant, and disables empty measurement inputs so
      // they don't end up as empty line-item properties.
      form.addEventListener('submit', function(e) {
        if (!variantInput.value) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }
        form.querySelectorAll('[data-jrw-measure]').forEach(function(input) {
          if (!input.value.trim()) input.disabled = true;
        });
      }, true);

      if (window.theme && window.theme.AjaxProduct) {
        // Impulse's AjaxProduct posts to /cart/add.js and dispatches the
        // 'ajaxProduct:added' event that CartDrawer listens for → drawer opens.
        new window.theme.AjaxProduct(form, '[data-jrw-submit]');
      }
      // If AjaxProduct isn't available the native POST to /cart/add fires as a fallback.
    }

    /* ── Measurement unit toggle (IN ⇄ CM) ── */
    var unitToggle = sectionEl.querySelector('[data-jrw-unit-toggle]');
    if (unitToggle) {
      var unitBtns = unitToggle.querySelectorAll('[data-jrw-unit]');
      var unitLabels = sectionEl.querySelectorAll('[data-jrw-unit-label]');
      var measureInputs = sectionEl.querySelectorAll('[data-jrw-measure]');
      var currentUnit = 'in';

      function setUnit(nextUnit) {
        if (nextUnit === currentUnit) return;
        var factor = nextUnit === 'cm' ? 2.54 : 1 / 2.54;
        measureInputs.forEach(function(input) {
          var raw = input.value.replace(',', '.').trim();
          if (!raw) return;
          var num = parseFloat(raw);
          if (isNaN(num)) return;
          var converted = num * factor;
          // 1 decimal for cm, 1 for in — keep it tidy
          input.value = (Math.round(converted * 10) / 10).toString();
        });
        unitLabels.forEach(function(el) { el.textContent = nextUnit; });
        unitBtns.forEach(function(btn) {
          btn.classList.toggle('is-active', btn.getAttribute('data-jrw-unit') === nextUnit);
        });
        currentUnit = nextUnit;
      }

      unitBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          setUnit(btn.getAttribute('data-jrw-unit'));
        });
      });
    }

    /* ── Reviews carousel (single card) ─── */
    var reviewsCarousel = sectionEl.querySelector('[data-jrw-reviews]');
    if (reviewsCarousel) {
      var rTrack = reviewsCarousel.querySelector('[data-jrw-reviews-track]');
      var rSlides = reviewsCarousel.querySelectorAll('.jrw-review');
      var rPrev = reviewsCarousel.querySelector('[data-jrw-reviews-prev]');
      var rNext = reviewsCarousel.querySelector('[data-jrw-reviews-next]');
      var rDots = reviewsCarousel.querySelectorAll('[data-jrw-reviews-dot]');
      var rTotal = rSlides.length;
      var rIndex = 0;

      if (rTotal <= 1) {
        if (rPrev) rPrev.style.display = 'none';
        if (rNext) rNext.style.display = 'none';
      }

      function rUpdate() {
        if (rTrack) rTrack.style.transform = 'translateX(-' + (rIndex * 100) + '%)';
        rDots.forEach(function(d, i) {
          d.classList.toggle('is-active', i === rIndex);
        });
      }
      function rGoTo(i) {
        rIndex = ((i % rTotal) + rTotal) % rTotal;
        rUpdate();
      }

      if (rPrev) rPrev.addEventListener('click', function() { rGoTo(rIndex - 1); });
      if (rNext) rNext.addEventListener('click', function() { rGoTo(rIndex + 1); });
      rDots.forEach(function(d, i) {
        d.addEventListener('click', function() { rGoTo(i); });
      });
      rUpdate();
    }

    /* ── Init ─────────────────────────── */
    updateVariant();

    /* ── Pass interest to reach-out CTA ── */
    // Reuses the same pattern as the wedding collection section.
    var reachLink = sectionEl.querySelector('[data-jcg-interest]');
    if (reachLink) {
      reachLink.addEventListener('click', function() {
        var interest = reachLink.getAttribute('data-jcg-interest');
        var source = reachLink.getAttribute('data-jcg-source') || '';
        if (!interest) return;
        var href = reachLink.getAttribute('href') || '';
        if (!href || href.charAt(0) === '#') return;
        try {
          var url = new URL(href, window.location.origin);
          url.searchParams.set('interest', interest);
          if (source) url.searchParams.set('source', source);
          // Include current variant so the atelier knows exactly what was configured
          var v = findVariant();
          if (v) {
            var optNames = optionNames();
            optNames.forEach(function(n, i) {
              url.searchParams.set(n.toLowerCase(), v['option' + (i + 1)]);
            });
          }
          reachLink.setAttribute('href', url.pathname + url.search + url.hash);
        } catch (err) {
          var sep = href.indexOf('?') === -1 ? '?' : '&';
          reachLink.setAttribute('href', href + sep + 'interest=' + encodeURIComponent(interest) + (source ? '&source=' + encodeURIComponent(source) : ''));
        }
      });
    }
  });
})();
